module.exports = __webpack_public_path__ + "static/media/gt-logo-light.17332cb0.png";